"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var BundleController = /*#__PURE__*/function (_PageController) {
  function BundleController() {
    var _this2;
    _classCallCheck(this, BundleController);
    _this2 = _callSuper(this, BundleController);
    _this2.toggleCollapseControl = '.toggleCollapseControl';
    _this2.toggleCollapseItem = '.toggleCollapseItem';
    _this2.itemDetails = '.more-details';
    _this2.toggleCollapse();
    _this2.showMoreButtonUpdateText();
    _this2.deviceReturnConfirmation();
    _this2.deviceBorrowAppeal();
    return _this2;
  }
  _inherits(BundleController, _PageController);
  return _createClass(BundleController, [{
    key: "toggleCollapse",
    value: function toggleCollapse() {
      var _this = this;
      $(document).on("click", _this.toggleCollapseControl, function (e) {
        var toggleButton = e.target;
        var selectedItem = $(toggleButton).parents(_this.toggleCollapseItem);
        selectedItem.find(_this.itemDetails).slideToggle(300, function () {
          selectedItem.toggleClass('expanded');
        });
      });
    }
  }, {
    key: "showMoreButtonUpdateText",
    value: function showMoreButtonUpdateText() {
      $("#showMoreFoto").click(function () {
        var currentValue = $(this).text();
        var expandedText = $(this).attr("data-expended-text");
        var notExpandedText = $(this).attr("data-not-expanded-text");
        if (currentValue === expandedText) {
          $(this).text(notExpandedText);
        } else {
          $(this).text(expandedText);
        }
      });
    }
  }, {
    key: "deviceReturnConfirmation",
    value: function deviceReturnConfirmation(textAreaInput) {
      var batteryConfirmation = $("#frm-bundleForm-returned_charged_battery");
      $(".require-device-return-confirmation").click(function (event) {
        event.preventDefault();
        var form = document.getElementById('frm-bundleForm');
        Nette.formErrors = [];
        var formElementValidationCorrent = true;
        $("input,textarea,select", textAreaInput).each(function (index) {
          var el = $(this)[0];
          var controlValidation = Nette.validateControl(el, null, false);
          if (controlValidation === false) {
            formElementValidationCorrent = false;
          }
        });
        Nette.showFormErrors(form, Nette.formErrors);
        if (!formElementValidationCorrent) {
          return formElementValidationCorrent;
        } else {
          $.confirm({
            useBootstrap: false,
            draggable: false,
            title: 'Vracíte zařízení plně dobité?',
            content: '<div class="returnDevice">Zařízení obsahující akumulátor je dobré vracet plně dobité pro udržení její kondice v co nejlepším stavu.</div>',
            boxWidth: '90%',
            buttons: {
              vratitSe: {
                text: 'Vrátit se',
                btnClass: 'jquery-confirm-no-action-button',
                keys: ['esc'],
                action: function action() {}
              },
              ne: {
                text: 'Ne',
                btnClass: 'jquery-confirm-button-no',
                action: function action() {
                  batteryConfirmation.val(0).change();
                  $("form").submit();
                }
              },
              ano: {
                text: 'Ano',
                btnClass: 'jquery-confirm-button-yes',
                keys: ['enter'],
                action: function action() {
                  batteryConfirmation.val(1).change();
                  $("form").submit();
                }
              }
            }
          });
        }
      });
    }
  }, {
    key: "deviceBorrowAppeal",
    value: function deviceBorrowAppeal(textAreaInput) {
      $(".appeal-to-charge-battery").click(function (event) {
        event.preventDefault();
        var form = document.getElementById('frm-bundleForm');
        Nette.formErrors = [];
        var formElementValidationCorrent = true;
        $("input,textarea,select", textAreaInput).each(function (index) {
          var el = $(this)[0];
          var controlValidation = Nette.validateControl(el, null, false);
          if (controlValidation === false) {
            formElementValidationCorrent = false;
          }
        });
        Nette.showFormErrors(form, Nette.formErrors);
        if (!formElementValidationCorrent) {
          return formElementValidationCorrent;
        } else {
          $.confirm({
            useBootstrap: false,
            draggable: false,
            title: 'Toto zařízení obsahuje baterii',
            content: '<p>Prosíme o plné dobití před jeho vrácením.</p>' + '<div class="borrowDevice"><img src="' + window.location.origin + '/img/icons/apple-battery-charging-icon.png" alt="Battery Icon"></div>',
            boxWidth: '90%',
            textAlign: 'center',
            buttons: {
              souhlas: {
                text: 'Beru na vědomí',
                btnClass: 'jquery-confirm-button-yes-borrow content-center',
                keys: ['enter'],
                action: function action() {
                  $("form").submit();
                }
              }
            },
            onOpenBefore: function onOpenBefore() {
              $(this.$body[0]).addClass("content-center");
            }
          });
        }
      });
    }
  }]);
}(PageController);